/*
  LAUVEE - Brosse L1 en 3D avec points interactifs (2026-09-21)
  Modele construit en code (three.js, charge a la demande depuis jsDelivr),
  d'apres les photos produit : base hexagonale au grain poudre, plaque de
  verre mat sur toute la face logo, bouton on/off hexagonal strie sur le
  flanc, corps cylindrique, espace (axe metal) entre le corps et la tete,
  tete en silicone a picots plus hauts en bordure.
  Rotation : 360 degres a l'horizontale, inclinaison limitee a la verticale
  pour que le logo ne puisse jamais se retrouver a l'envers.
  Coloris noir / blanc / rose, modes drainage (logo blanc) et massage (jaune).
  Si WebGL ou le chargement echoue, l'image de repli reste affichee.
*/
(function () {
  var THREE_URL = 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.min.js';

  // Dimensions (unite = largeur pointe a pointe de l'hexagone), relevees
  // sur les photos de profil et de dessus.
  var HEX_W = 1;
  var HEX_H = 0.82;
  var BASE_T = 0.37;
  var BODY_R = 0.37;
  var BODY_L = 0.55;
  var GAP = 0.035;
  var HEAD_R = 0.366;
  var HEAD_T = 0.045;
  var HEAD_Z = -(BODY_L + GAP);
  var FACE_Z = HEAD_Z - HEAD_T;
  var GLASS_Z = BASE_T + 0.012; // dessus de la plaque de verre
  // Bouton : au milieu du pan a 10 h (vu cote logo), entre le sommet gauche
  // et le sommet haut gauche de l'hexagone. Normale a 150 degres.
  var BTN_QX = HEX_H / 2 / Math.tan(Math.PI / 3);
  var BTN_MID = [-HEX_W / 2 + BTN_QX / 2, HEX_H / 4];
  var BTN_N = [-Math.sin(Math.PI / 3), Math.cos(Math.PI / 3)];
  var BTN_DIST = Math.hypot(BTN_MID[0], BTN_MID[1]);

  var COLORS = {
    blanc: { body: 0xefece6, head: 0xf5f3ee, glass: 0xf7f6f2, logo: '#ffffff', logoAlpha: 0.95, neck: 0xa8a9ad },
    noir: { body: 0x1c1d20, head: 0x17181a, glass: 0x232428, logo: '#6b6e75', logoAlpha: 0.95, neck: 0x55575c },
    rose: { body: 0xebbdb4, head: 0xf2c8bf, glass: 0xf6d0c8, logo: '#3a302d', logoAlpha: 0.9, neck: 0xa19a98 }
  };

  // Modes : couleur du logo allume (lumiere forte et constante) et mouvement
  // de la tete. osc = rotation, shake = oscillation horizontale / verticale,
  // push = avancee de la tete. Drainage > massage sur tous les reglages.
  var MODES = {
    drainage: { glow: 0xffffff, glowMax: 1.15, osc: 0.075, shake: 0.013, freq: 13, push: 0.016, pulseHz: 2.4, sharp: true },
    massage: { glow: 0xffb000, glowMax: 1.35, osc: 0.045, shake: 0.008, freq: 8, push: 0.009, pulseHz: 1.1, sharp: false }
  };

  // Points d'ancrage : position et normale dans le repere du modele.
  // Le logo est sur la face +z, la tete pointe vers -z, le bouton sur le
  // pan a 10 h.
  var ANCHORS = {
    logo: { p: [0.22, 0.2, GLASS_Z], n: [0, 0, 1] },
    // « + » decale le long du pan (vers le sommet du haut) pour ne pas
    // masquer le bouton.
    bouton: {
      p: [BTN_MID[0] + BTN_N[0] * 0.008 + 0.5 * 0.15, BTN_MID[1] + BTN_N[1] * 0.008 + 0.866 * 0.15, BASE_T / 2],
      n: [BTN_N[0], BTN_N[1], 0]
    },
    base_haut: { p: [0.15, HEX_H / 2, BASE_T / 2], n: [0, 1, 0] },
    base_cote: { p: [-HEX_W / 2, 0, BASE_T / 2], n: [-1, 0, 0] },
    base_bas: { p: [0.1, -HEX_H / 2, BASE_T / 2], n: [0, -1, 0] },
    corps: { p: [BODY_R, 0.02, -BODY_L / 2], n: [1, 0, 0] },
    tete_bord: { p: [-HEAD_R * 0.72, HEAD_R * 0.69, HEAD_Z - HEAD_T / 2], n: [-0.72, 0.69, 0] },
    tete_picots: { p: [0.08, -0.1, FACE_Z - 0.045], n: [0, 0, -1] }
  };

  // Logo officiel LAUVEE PARIS (logo-foot.svg, viewBox 112 x 42), trace
  // vectoriel dessine dans la texture : net a toutes les tailles.
  var LOGO_W = 112;
  var LOGO_H = 42;
  var LOGO_PATHS = [
    "M44.4904 35.1058C44.3074 34.8935 44.0886 34.7269 43.837 34.6027C43.5855 34.4786 43.3079 34.4165 43.0106 34.4165H40.1295V41.3748H40.8155V38.8071H43.0694C43.4745 38.8071 43.8272 38.7026 44.1278 38.4935C44.4283 38.2844 44.6602 38.01 44.8301 37.6735C44.9967 37.337 45.0783 36.981 45.0783 36.602C45.0783 36.3341 45.0261 36.0728 44.9215 35.8114C44.817 35.5501 44.6733 35.3181 44.4904 35.1058ZM44.2258 37.3828C44.1147 37.6245 43.9579 37.8205 43.7554 37.9708C43.5529 38.1211 43.3144 38.1962 43.04 38.1962H40.8155V35.0209H42.9812C43.236 35.0209 43.4712 35.0927 43.6835 35.2332C43.8958 35.3737 44.0657 35.5664 44.1996 35.8049C44.3303 36.0466 44.3956 36.3113 44.3956 36.5987C44.3956 36.8862 44.3401 37.141 44.229 37.3828H44.2258Z",
    "M49.6646 34.4131L46.7541 41.3714H47.4891L48.358 39.1957H51.5396L52.4085 41.3714H53.1336L50.2428 34.4131H49.6646ZM48.5736 38.6567L49.9488 35.2167L51.324 38.6567H48.5736Z",
    "M60.1665 38.2843C60.3985 38.0817 60.5781 37.8334 60.7055 37.5394C60.8329 37.2454 60.8982 36.9318 60.8982 36.5986C60.8982 36.3307 60.846 36.0694 60.7447 35.808C60.6435 35.5467 60.4997 35.3147 60.3135 35.1024C60.1273 34.89 59.9085 34.7234 59.6602 34.5993C59.412 34.4752 59.1376 34.4131 58.837 34.4131H55.8972V41.3714H56.5831V38.8037H58.6411L60.2776 41.3714H61.0518L59.3466 38.6861C59.6602 38.6207 59.9313 38.4868 60.1633 38.2843H60.1665ZM56.5831 38.1961V35.0207H58.7978C59.0592 35.0207 59.2944 35.0958 59.51 35.2396C59.7223 35.3866 59.8921 35.5793 60.0195 35.8178C60.1469 36.0563 60.209 36.3176 60.209 36.5986C60.209 36.8795 60.1535 37.1311 60.0424 37.3761C59.9313 37.6211 59.7745 37.8204 59.572 37.9674C59.3695 38.1176 59.131 38.1928 58.8566 38.1928H56.5831V38.1961Z",
    "M64.7462 34.4131H64.0602V41.3714H64.7462V34.4131Z",
    "M71.8705 37.9675C71.5112 37.8238 71.0833 37.6997 70.5868 37.5951C70.1425 37.4906 69.7767 37.3893 69.4892 37.2913C69.2018 37.1933 68.9894 37.0659 68.8555 36.9091C68.7216 36.7523 68.653 36.5367 68.653 36.2623C68.653 35.8637 68.7967 35.5501 69.0809 35.3182C69.3651 35.0862 69.8094 34.9719 70.4169 34.9719C70.626 34.9719 70.8252 34.9915 71.0114 35.0307C71.1976 35.0699 71.3708 35.1222 71.5341 35.1875C71.6974 35.2528 71.8444 35.3312 71.9751 35.4194C72.1057 35.5076 72.2201 35.6089 72.3181 35.72L72.6512 35.1712C72.4553 34.9948 72.2429 34.8477 72.0175 34.7301C71.7921 34.6125 71.5472 34.5243 71.2826 34.459C71.018 34.3969 70.7305 34.3643 70.4267 34.3643C69.9433 34.3643 69.5154 34.4394 69.143 34.5929C68.7706 34.7465 68.4766 34.9719 68.2643 35.2692C68.0519 35.5664 67.9474 35.9291 67.9474 36.3603C67.9474 36.7327 68.0291 37.03 68.1957 37.2554C68.3623 37.4808 68.6105 37.6605 68.9437 37.7977C69.2769 37.9349 69.6852 38.059 70.1687 38.1701C70.626 38.2746 71.0114 38.3824 71.325 38.4935C71.6386 38.6046 71.8738 38.7451 72.0306 38.9182C72.1874 39.0913 72.2658 39.32 72.2658 39.6075C72.2658 40.006 72.109 40.3066 71.7987 40.5059C71.4884 40.7084 71.0539 40.8097 70.4986 40.8097C70.2373 40.8097 69.9857 40.7835 69.7408 40.7345C69.4958 40.6855 69.2671 40.6169 69.0548 40.5222C68.8424 40.4307 68.6497 40.3295 68.4766 40.2151C68.3035 40.1008 68.1532 39.9799 68.0291 39.8492L67.6861 40.4079C67.9409 40.6365 68.2153 40.8227 68.5093 40.973C68.8033 41.12 69.1136 41.2311 69.4468 41.3062C69.7767 41.3814 70.1197 41.4173 70.479 41.4173C70.8383 41.4173 71.1813 41.3814 71.4884 41.3062C71.7954 41.2311 72.06 41.1168 72.2821 40.9599C72.5042 40.8031 72.6774 40.6071 72.8015 40.3719C72.9256 40.1367 72.9877 39.859 72.9877 39.5389C72.9877 39.1207 72.8897 38.7908 72.6937 38.5458C72.4977 38.3008 72.2201 38.108 71.8607 37.9643L71.8705 37.9675Z",
    "M53.7053 6.479H50.7915C50.7033 6.479 50.6707 6.59334 50.7458 6.63908C51.1247 6.86449 51.68 7.36104 51.68 8.34108V21.1698C51.68 28.6802 41.5864 28.6802 41.5864 21.1698V8.34108C41.5864 7.36104 42.1417 6.86449 42.5206 6.63908C42.5958 6.59334 42.5631 6.479 42.4749 6.479H37.0426C36.9544 6.479 36.9218 6.59334 36.9969 6.63908C37.3758 6.86449 37.9311 7.36104 37.9311 8.34108V21.1698C37.9311 31.0585 52.82 31.0585 52.82 21.1698V8.34108C52.82 7.36104 53.3754 6.86449 53.7543 6.63908C53.8294 6.59334 53.7967 6.479 53.7085 6.479H53.7053Z",
    "M14.8073 24.5379L14.3532 24.8581C14.301 24.894 14.2618 24.9463 14.2389 25.0051C14.069 25.4559 13.3373 26.6744 11.2565 27.086C9.50894 27.4291 6.27832 27.4846 4.72671 27.4911V8.50769C4.72671 7.43945 5.33102 6.89716 5.74588 6.65214C5.82754 6.60314 5.79161 6.479 5.69688 6.479H0.0947497C1.98567e-05 6.479 -0.0359122 6.60314 0.0457515 6.65214C0.457336 6.89716 1.06491 7.43945 1.06491 8.50769V26.1942C1.06491 27.2624 0.460603 27.8047 0.0457515 28.0498C-0.0359122 28.0988 1.98567e-05 28.2229 0.0947497 28.2229H14.8432C14.9183 28.2229 14.9771 28.1641 14.9771 28.089V24.6229C14.9771 24.5347 14.8791 24.4857 14.8073 24.5347V24.5379Z",
    "M34.2661 26.5209L27.3181 6.4888L25.4138 6.479L18.4691 26.5046C18.1653 27.4356 17.5773 27.906 17.2539 28.1053C17.1984 28.138 17.2213 28.2229 17.2866 28.2229H20.0893C20.1579 28.2229 20.184 28.1314 20.1252 28.0955C19.8149 27.8929 19.3249 27.4585 19.5438 26.8182L21.3567 21.588H28.762L30.5782 26.8214C30.7905 27.4585 30.3038 27.8929 29.9967 28.0955C29.9379 28.1347 29.964 28.2229 30.0359 28.2229H35.442C35.5074 28.2229 35.5302 28.138 35.4747 28.1053C35.1546 27.9093 34.5699 27.4389 34.2628 26.5176L34.2661 26.5209ZM21.5429 21.0653L25.0642 10.9121L28.3177 20.2911C28.468 20.7321 28.334 21.0653 27.7167 21.0653H21.5429Z",
    "M75.2645 6.479H72.4618C72.3932 6.479 72.3671 6.57047 72.4259 6.60641C72.7362 6.80895 73.2262 7.24344 73.0073 7.88373L67.4901 23.7898L61.973 7.8772C61.7606 7.24017 62.2473 6.80568 62.5544 6.60641C62.6132 6.56721 62.5871 6.479 62.5185 6.479H57.1123C57.047 6.479 57.0241 6.56394 57.0797 6.59661C57.3998 6.79262 57.9845 7.26304 58.2916 8.18428L65.2395 28.2164L67.1439 28.2262L68.0879 25.5016L74.0886 8.19735C74.3924 7.26631 74.9803 6.79588 75.3037 6.59661C75.3593 6.56394 75.3364 6.479 75.2711 6.479H75.2645Z",
    "M83.7542 3.50624C86.5438 3.86886 88.7063 2.55887 89.2714 2.17338C89.353 2.11785 89.3726 2.00678 89.3171 1.9251L88.1019 0.157761C88.0562 0.0924244 87.9811 0.0532227 87.9027 0.0532227H87.1775C87.0893 0.0532227 87.0077 0.105492 86.9652 0.183895C86.0604 1.88264 84.4597 2.85941 83.7117 3.2449C83.5876 3.30697 83.6203 3.49317 83.7574 3.50951L83.7542 3.50624Z",
    "M93.5277 6.4953H83.0225V6.48877H78.482C78.3938 6.48877 78.3612 6.60311 78.4363 6.64884C78.8152 6.87425 79.3673 7.37081 79.3673 8.34758V26.364C79.3673 27.3408 78.8119 27.8374 78.4363 28.0628C78.3612 28.1085 78.3938 28.2229 78.482 28.2229H93.5277C93.6029 28.2229 93.6617 28.1641 93.6617 28.0889V24.6228C93.6617 24.5346 93.5637 24.4856 93.4918 24.5346L93.0378 24.8548C92.9855 24.8907 92.9463 24.943 92.9234 25.0018C92.7536 25.4526 92.0219 26.6711 89.9411 27.0827C88.0269 27.4584 84.3389 27.4911 83.0193 27.4878V17.6155H86.8672C87.9289 17.6155 88.5854 18.6609 88.8762 19.2555C88.9186 19.3437 89.0493 19.311 89.0493 19.2163V15.4921C89.0493 15.3941 88.9186 15.3647 88.8762 15.4529C88.5887 16.0475 87.9289 17.0928 86.8672 17.0928H83.0193V7.2238C84.3389 7.2238 88.0269 7.2532 89.9411 7.62889C92.0219 8.0405 92.7503 9.25902 92.9234 9.70984C92.9463 9.76865 92.9855 9.82092 93.0378 9.85685L93.4918 10.177C93.5637 10.226 93.6617 10.177 93.6617 10.0888V6.62271C93.6617 6.54757 93.6029 6.48877 93.5277 6.48877V6.4953Z",
    "M108.283 7.632C110.364 8.04362 111.092 9.26214 111.265 9.71296C111.288 9.77176 111.327 9.82403 111.379 9.85997L111.833 10.1801C111.905 10.2291 112.003 10.1801 112.003 10.0919V6.62582C112.003 6.55069 111.945 6.49188 111.869 6.49188H101.364V6.48535H96.8237C96.7355 6.48535 96.7028 6.59969 96.778 6.64543C97.1569 6.87084 97.7089 7.36739 97.7089 8.34417V26.3606C97.7089 27.3374 97.1536 27.834 96.778 28.0594C96.7028 28.1051 96.7355 28.2194 96.8237 28.2194H111.869C111.945 28.2194 112.003 28.1606 112.003 28.0855V24.6194C112.003 24.5312 111.905 24.4822 111.833 24.5312L111.379 24.8514C111.327 24.8873 111.288 24.9396 111.265 24.9984C111.095 25.4492 110.364 26.6677 108.283 27.0793C106.369 27.455 102.681 27.4877 101.361 27.4844V17.6121H105.209C106.271 17.6121 106.927 18.6575 107.218 19.252C107.26 19.3402 107.391 19.3076 107.391 19.2128V15.4887C107.391 15.3907 107.26 15.3613 107.218 15.4495C106.93 16.044 106.271 17.0894 105.209 17.0894H101.361V7.22038C102.681 7.22038 106.369 7.24978 108.283 7.62547V7.632Z"
  ];

  // Icones animees des caracteristiques (dans la note, pastille noire).
  var FEATURE_ICONS = {
    dmc:
      '<svg viewBox="0 0 44 28"><circle class="i-ring" cx="22" cy="14" r="4.5" /><circle class="i-ring i-late" cx="22" cy="14" r="4.5" /><circle class="i-core" cx="22" cy="14" r="2.6" /></svg>',
    vibration:
      '<svg viewBox="0 0 44 28"><rect class="i-bar" x="11" y="8" width="2.6" height="12" rx="1.3" /><rect class="i-bar i-b2" x="16.5" y="5" width="2.6" height="18" rx="1.3" /><rect class="i-bar i-b3" x="22" y="3" width="2.6" height="22" rx="1.3" /><rect class="i-bar i-b2" x="27.5" y="5" width="2.6" height="18" rx="1.3" /><rect class="i-bar" x="33" y="8" width="2.6" height="12" rx="1.3" /></svg>',
    silicone:
      '<svg viewBox="0 0 44 28"><path class="i-shield" d="M22 3.5 30.5 6.8V13.2C30.5 18.4 26.9 22.2 22 24.2 17.1 22.2 13.5 18.4 13.5 13.2V6.8Z" /><path class="i-check" d="M18.2 13.8 21 16.6 26.2 10.8" /></svg>',
    massage:
      '<svg viewBox="0 0 44 28"><circle class="i-track" cx="22" cy="14" r="7.5" /><g class="i-orbit"><path class="i-trail" d="M22 6.5A7.5 7.5 0 0 0 14.5 14" /><circle class="i-dot" cx="22" cy="6.5" r="2.3" /></g></svg>'
  };

  var threePromise = null;
  function loadThree() {
    // import() passe par new Function : Shopify minifie les assets JS et
    // reecrit un import() litteral en require(), qui n'existe pas ici.
    if (!threePromise) threePromise = new Function('u', 'return import(u)')(THREE_URL);
    return threePromise;
  }

  function roundedHexShape(THREE, w, h, r) {
    var hw = w / 2;
    var hh = h / 2;
    var qx = hh / Math.tan(Math.PI / 3); // decalage des sommets haut/bas
    var pts = [
      [hw, 0],
      [hw - qx, hh],
      [-hw + qx, hh],
      [-hw, 0],
      [-hw + qx, -hh],
      [hw - qx, -hh]
    ];
    var shape = new THREE.Shape();
    for (var i = 0; i < pts.length; i++) {
      var prev = pts[(i + pts.length - 1) % pts.length];
      var cur = pts[i];
      var next = pts[(i + 1) % pts.length];
      var d1 = Math.hypot(cur[0] - prev[0], cur[1] - prev[1]);
      var d2 = Math.hypot(next[0] - cur[0], next[1] - cur[1]);
      var a = [cur[0] + ((prev[0] - cur[0]) * r) / d1, cur[1] + ((prev[1] - cur[1]) * r) / d1];
      var b = [cur[0] + ((next[0] - cur[0]) * r) / d2, cur[1] + ((next[1] - cur[1]) * r) / d2];
      if (i === 0) shape.moveTo(a[0], a[1]);
      else shape.lineTo(a[0], a[1]);
      shape.quadraticCurveTo(cur[0], cur[1], b[0], b[1]);
    }
    shape.closePath();
    return shape;
  }

  function logoTexture(THREE, color, alpha, blur) {
    var c = document.createElement('canvas');
    c.width = 1024;
    c.height = 512;
    var g = c.getContext('2d');
    g.clearRect(0, 0, c.width, c.height);
    g.globalAlpha = alpha;
    g.fillStyle = color;
    if (blur) {
      g.shadowColor = color;
      g.shadowBlur = blur;
    }
    var passes = blur ? 5 : 1;
    // Logo sur ~75 % de la largeur du plan (0,56) = ~42 % de la face.
    var scale = 768 / LOGO_W;
    g.setTransform(scale, 0, 0, scale, (c.width - LOGO_W * scale) / 2, (c.height - LOGO_H * scale) / 2);
    var shapes = LOGO_PATHS.map(function (d) {
      return new Path2D(d);
    });
    for (var p = 0; p < passes; p++) {
      shapes.forEach(function (shape) {
        g.fill(shape);
      });
    }
    var tex = new THREE.CanvasTexture(c);
    tex.colorSpace = THREE.SRGBColorSpace;
    tex.anisotropy = 8;
    return tex;
  }

  // Carte de normales a partir d'un champ de hauteur (grain, stries).
  function normalTexture(THREE, size, heightAt, strength, repeatX, repeatY) {
    var hgt = new Float32Array(size * size);
    for (var y = 0; y < size; y++) for (var x = 0; x < size; x++) hgt[y * size + x] = heightAt(x, y);
    var data = new Uint8Array(size * size * 4);
    for (y = 0; y < size; y++) {
      for (x = 0; x < size; x++) {
        var l = hgt[y * size + ((x + size - 1) % size)];
        var r = hgt[y * size + ((x + 1) % size)];
        var u = hgt[((y + size - 1) % size) * size + x];
        var d = hgt[((y + 1) % size) * size + x];
        var nx = (l - r) * strength;
        var ny = (d - u) * strength;
        var len = Math.sqrt(nx * nx + ny * ny + 1);
        var i = (y * size + x) * 4;
        data[i] = ((nx / len) * 0.5 + 0.5) * 255;
        data[i + 1] = ((ny / len) * 0.5 + 0.5) * 255;
        data[i + 2] = ((1 / len) * 0.5 + 0.5) * 255;
        data[i + 3] = 255;
      }
    }
    var tex = new THREE.DataTexture(data, size, size, THREE.RGBAFormat);
    tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
    tex.repeat.set(repeatX || 1, repeatY || 1);
    tex.generateMipmaps = true;
    tex.minFilter = THREE.LinearMipmapLinearFilter;
    tex.magFilter = THREE.LinearFilter;
    tex.anisotropy = 8;
    tex.needsUpdate = true;
    return tex;
  }

  // Grain poudre (peinture soft-touch) : bruit fin legerement lisse.
  function grainHeights(size) {
    var raw = new Float32Array(size * size);
    for (var i = 0; i < raw.length; i++) raw[i] = Math.random();
    return function (x, y) {
      var s = 0;
      for (var dy = -1; dy <= 1; dy++)
        for (var dx = -1; dx <= 1; dx++) s += raw[((y + dy + size) % size) * size + ((x + dx + size) % size)];
      return s / 9;
    };
  }

  // Petit studio lumineux : lumieres de cote, de dessus et de derriere
  // uniquement. Aucune source face au modele, pour qu'il n'y ait pas de
  // surbrillance quand la face logo passe devant l'ecran.
  function studioEnvironment(THREE, renderer) {
    var scene = new THREE.Scene();
    var room = new THREE.Mesh(
      new THREE.BoxGeometry(10, 8, 10),
      new THREE.MeshBasicMaterial({ color: 0x9c9c9c, side: THREE.BackSide })
    );
    scene.add(room);
    function panel(w, h, x, y, z, intensity) {
      var m = new THREE.Mesh(
        new THREE.PlaneGeometry(w, h),
        new THREE.MeshBasicMaterial({ color: new THREE.Color(intensity, intensity, intensity), side: THREE.DoubleSide })
      );
      m.position.set(x, y, z);
      m.lookAt(0, 0, 0);
      scene.add(m);
    }
    panel(6, 3, 0, 3.9, -0.5, 3);
    panel(2.2, 5, -4.9, 0.6, -0.8, 2.6);
    panel(2.2, 5, 4.9, 0.3, -1.2, 1.8);
    panel(5, 2.5, 0, 0.5, -4.9, 1.2);
    var pmrem = new THREE.PMREMGenerator(renderer);
    var env = pmrem.fromScene(scene, 0.05).texture;
    pmrem.dispose();
    return env;
  }

  function buildBrush(THREE, palette) {
    var group = new THREE.Group();
    var solids = [];
    var S = 512;
    var grain = grainHeights(S);

    function shadowed(mesh) {
      mesh.castShadow = true;
      mesh.receiveShadow = true;
      return mesh;
    }

    // Corps : plastique soft-touch mat au grain poudre visible.
    var bodyMat = new THREE.MeshPhysicalMaterial({
      color: palette.body,
      roughness: 0.62,
      metalness: 0,
      specularIntensity: 0.12,
      sheen: 0.08,
      sheenRoughness: 0.9,
      sheenColor: new THREE.Color(0xffffff),
      normalMap: normalTexture(THREE, S, grain, 2.2, 1.6, 1.6),
      normalScale: new THREE.Vector2(0.11, 0.11)
    });
    var cylMat = bodyMat.clone();
    cylMat.normalMap = normalTexture(THREE, S, grain, 2.2, 2.4, 0.7);

    // Plaque de verre au toucher mat sur toute la face logo.
    var glassMat = new THREE.MeshPhysicalMaterial({
      color: palette.glass,
      roughness: 0.42,
      metalness: 0,
      ior: 1.5,
      // Aucun reflet speculaire : la face logo ne s'illumine pas quand
      // elle passe face a l'ecran.
      specularIntensity: 0.04,
      envMapIntensity: 0.55,
      normalMap: normalTexture(THREE, 256, grainHeights(256), 1.2, 3, 3),
      normalScale: new THREE.Vector2(0.06, 0.06)
    });

    // Silicone de la tete : mat, doux.
    var headMat = new THREE.MeshPhysicalMaterial({
      color: palette.head,
      roughness: 0.85,
      metalness: 0,
      specularIntensity: 0.3,
      sheen: 0.55,
      sheenRoughness: 0.7,
      sheenColor: new THREE.Color(0xffffff)
    });

    // Axe visible dans l'espace entre le corps et la tete (metal satine).
    var neckMat = new THREE.MeshStandardMaterial({ color: palette.neck, roughness: 0.38, metalness: 0.85 });

    // Base hexagonale arrondie (bevel = aretes adoucies).
    var bevel = 0.045;
    var baseGeo = new THREE.ExtrudeGeometry(roundedHexShape(THREE, HEX_W - bevel * 2, HEX_H - bevel * 2, 0.085), {
      depth: BASE_T - bevel * 2,
      bevelEnabled: true,
      bevelThickness: bevel,
      bevelSize: bevel,
      bevelSegments: 10,
      curveSegments: 18
    });
    baseGeo.translate(0, 0, bevel);
    var base = shadowed(new THREE.Mesh(baseGeo, bodyMat));
    group.add(base);
    solids.push(base);

    // Liseré sombre autour de la plaque de verre.
    var lineMat = new THREE.MeshStandardMaterial({ color: 0x000000, roughness: 0.9, transparent: true, opacity: 0.35 });
    var line = new THREE.Mesh(new THREE.ShapeGeometry(roundedHexShape(THREE, HEX_W - 0.085, HEX_H - 0.085, 0.07), 18), lineMat);
    line.position.z = BASE_T + 0.0006;
    group.add(line);

    // Plaque de verre legerement en relief, bords arrondis.
    var gb = 0.005;
    var glassGeo = new THREE.ExtrudeGeometry(roundedHexShape(THREE, HEX_W - 0.1 - gb * 2, HEX_H - 0.1 - gb * 2, 0.065), {
      depth: 0.004,
      bevelEnabled: true,
      bevelThickness: gb,
      bevelSize: gb,
      bevelSegments: 5,
      curveSegments: 18
    });
    var glass = shadowed(new THREE.Mesh(glassGeo, glassMat));
    glass.position.z = BASE_T + gb - 0.002;
    group.add(glass);
    solids.push(glass);

    // Logo imprime sur le verre. emissiveMap = logo blanc : seules les
    // lettres s'allument quand un mode est actif.
    var logoMat = new THREE.MeshStandardMaterial({
      map: logoTexture(THREE, palette.logo, palette.logoAlpha),
      emissiveMap: logoTexture(THREE, '#ffffff', 1),
      emissive: new THREE.Color(0x000000),
      emissiveIntensity: 0,
      transparent: true,
      roughness: 0.95,
      envMapIntensity: 0.3,
      // Hors tone mapping : le jaune et le blanc allumes gardent leur
      // couleur franche au lieu d'etre delaves.
      toneMapped: false,
      polygonOffset: true,
      polygonOffsetFactor: -2
    });
    var logo = new THREE.Mesh(new THREE.PlaneGeometry(0.56, 0.28), logoMat);
    logo.position.set(0, -0.005, GLASS_Z + 0.0015);
    group.add(logo);

    // Halo lumineux autour des lettres (texte floute, melange additif).
    var haloMat = new THREE.MeshBasicMaterial({
      map: logoTexture(THREE, '#ffffff', 1, 44),
      color: new THREE.Color(0xffffff),
      transparent: true,
      opacity: 0,
      blending: THREE.AdditiveBlending,
      depthWrite: false,
      toneMapped: false
    });
    var halo = new THREE.Mesh(new THREE.PlaneGeometry(0.56, 0.28), haloMat);
    halo.scale.set(1.08, 1.12, 1);
    halo.position.set(0, -0.005, GLASS_Z + 0.0028);
    halo.visible = false; // halo supprime : il faisait briller le logo de face

    // Bouton on/off : petit hexagone en relief, strie en diagonale, sur le
    // flanc plat du dessus.
    var stripes = function (x, y) {
      return 0.5 + 0.5 * Math.sin(((x + y) / 128) * Math.PI * 2 * 7);
    };
    var btnMat = new THREE.MeshPhysicalMaterial({
      color: palette.body,
      roughness: 0.55,
      specularIntensity: 0.5,
      normalMap: normalTexture(THREE, 128, stripes, 4, 1, 1),
      normalScale: new THREE.Vector2(0.8, 0.8)
    });
    var btnShape = new THREE.Shape();
    for (var bi = 0; bi < 6; bi++) {
      var ba = (bi / 6) * Math.PI * 2 + Math.PI / 6;
      if (bi === 0) btnShape.moveTo(Math.cos(ba) * 0.058, Math.sin(ba) * 0.058);
      else btnShape.lineTo(Math.cos(ba) * 0.058, Math.sin(ba) * 0.058);
    }
    btnShape.closePath();
    var btnGeo = new THREE.ExtrudeGeometry(btnShape, {
      depth: 0.002,
      bevelEnabled: true,
      bevelThickness: 0.004,
      bevelSize: 0.006,
      bevelSegments: 4
    });
    // UV du bouton ramenes sur 0..1 pour les stries.
    var uv = btnGeo.attributes.uv;
    for (var ui = 0; ui < uv.count; ui++) uv.setXY(ui, uv.getX(ui) / 0.13 + 0.5, uv.getY(ui) / 0.13 + 0.5);
    var btn = shadowed(new THREE.Mesh(btnGeo, btnMat));
    btn.rotation.x = -Math.PI / 2;
    btn.position.set(0, BTN_DIST + 0.003, 0);
    // Fine gorge sombre autour du bouton (comme sur la photo rose).
    var btnRing = new THREE.Shape();
    for (var ri = 0; ri < 6; ri++) {
      var ra = (ri / 6) * Math.PI * 2 + Math.PI / 6;
      if (ri === 0) btnRing.moveTo(Math.cos(ra) * 0.071, Math.sin(ra) * 0.071);
      else btnRing.lineTo(Math.cos(ra) * 0.071, Math.sin(ra) * 0.071);
    }
    btnRing.closePath();
    var ring = new THREE.Mesh(
      new THREE.ShapeGeometry(btnRing),
      new THREE.MeshStandardMaterial({ color: 0x000000, transparent: true, opacity: 0.4, roughness: 1 })
    );
    ring.rotation.x = -Math.PI / 2;
    ring.position.set(0, BTN_DIST + 0.0008, 0);
    var btnPivot = new THREE.Group();
    btnPivot.rotation.z = Math.PI / 3; // +y tourne vers le pan a 10 h
    btnPivot.position.z = BASE_T / 2;
    btnPivot.add(ring);
    btnPivot.add(btn);
    group.add(btnPivot);

    // Corps cylindrique + fin chanfrein a la jonction avec la base.
    var body = shadowed(new THREE.Mesh(new THREE.CylinderGeometry(BODY_R, BODY_R, BODY_L, 128, 1, true), cylMat));
    body.rotation.x = Math.PI / 2;
    body.position.z = -BODY_L / 2;
    group.add(body);
    solids.push(body);

    var ledge = shadowed(new THREE.Mesh(new THREE.TorusGeometry(BODY_R + 0.003, 0.006, 12, 128), bodyMat));
    ledge.position.z = -0.002;
    group.add(ledge);

    // Dessus du corps (visible dans l'espace sous la tete).
    var cap = shadowed(new THREE.Mesh(new THREE.CircleGeometry(BODY_R, 128), cylMat));
    cap.rotation.y = Math.PI;
    cap.position.z = -BODY_L;
    group.add(cap);

    // Axe metal dans l'espace.
    var neck = shadowed(new THREE.Mesh(new THREE.CylinderGeometry(0.2, 0.2, GAP + 0.01, 64), neckMat));
    neck.rotation.x = Math.PI / 2;
    neck.position.z = -BODY_L - GAP / 2;
    group.add(neck);

    // Tete : disque en silicone aux bords arrondis + picots, dans un groupe a
    // part pour pouvoir l'animer (oscillation + pulsation) selon le mode.
    var head = new THREE.Group();
    group.add(head);
    var prof = [
      [0, 0],
      [HEAD_R - 0.012, 0],
      [HEAD_R - 0.002, 0.006],
      [HEAD_R, 0.02],
      [HEAD_R - 0.003, 0.036],
      [HEAD_R - 0.014, HEAD_T],
      [0, HEAD_T]
    ].map(function (p) {
      return new THREE.Vector2(p[0], p[1]);
    });
    var diskGeo = new THREE.LatheGeometry(prof, 128);
    diskGeo.rotateX(-Math.PI / 2); // l'axe du tour passe de +y a -z
    var disk = shadowed(new THREE.Mesh(diskGeo, headMat));
    disk.position.z = HEAD_Z;
    head.add(disk);
    solids.push(disk);

    // Picots : pointes effilees a bout arrondi, en spirale, plus hautes en
    // bordure (comme sur la vraie tete).
    // Picot : tige legerement conique, bout arrondi (demi-sphere).
    var pinProf = [
      [0.0085, 0],
      [0.0078, 0.45],
      [0.007, 0.72],
      [0.006, 0.84],
      [0.0045, 0.93],
      [0.0024, 0.985],
      [0, 1]
    ].map(function (p) {
      return new THREE.Vector2(p[0], p[1]);
    });
    var pinGeo = new THREE.LatheGeometry(pinProf, 12);
    pinGeo.rotateX(-Math.PI / 2);
    var count = 640;
    var pins = new THREE.InstancedMesh(pinGeo, headMat, count);
    pins.castShadow = true;
    pins.receiveShadow = true;
    var m = new THREE.Matrix4();
    var ident = new THREE.Quaternion();
    var golden = Math.PI * (3 - Math.sqrt(5));
    var maxR = HEAD_R - 0.018;
    for (var k = 0; k < count; k++) {
      var rr = maxR * Math.sqrt((k + 0.5) / count);
      var th = k * golden;
      var t = rr / maxR;
      var len = 0.018 + 0.022 * Math.pow(t, 2.4);
      var thick = 1 - 0.18 * t;
      m.compose(new THREE.Vector3(Math.cos(th) * rr, Math.sin(th) * rr, FACE_Z + 0.001), ident, new THREE.Vector3(thick, thick, len));
      pins.setMatrixAt(k, m);
    }
    head.add(pins);

    // Recentrer le modele sur son volume.
    var box = new THREE.Box3().setFromObject(group);
    var center = box.getCenter(new THREE.Vector3());
    var pivot = new THREE.Group();
    group.position.sub(center);
    pivot.add(group);
    return {
      pivot: pivot,
      inner: group,
      head: head,
      bodyMat: bodyMat,
      cylMat: cylMat,
      btnMat: btnMat,
      glassMat: glassMat,
      headMat: headMat,
      neckMat: neckMat,
      logoMat: logoMat,
      haloMat: haloMat,
      solids: solids,
      radius: box.getSize(new THREE.Vector3()).length() / 2
    };
  }

  function init(root) {
    if (!root || root.dataset.lv3dReady) return;
    root.dataset.lv3dReady = '1';

    var stage = root.querySelector('[data-lv3d-stage]');
    var canvasWrap = root.querySelector('[data-lv3d-canvas]');
    var points = Array.prototype.slice.call(root.querySelectorAll('[data-lv3d-point]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-lv3d-chip]'));
    var panel = root.querySelector('[data-lv3d-panel]');
    var modeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-lv3d-mode]'));
    var colorBtns = Array.prototype.slice.call(root.querySelectorAll('[data-lv3d-color]'));
    var modeDesc = root.querySelector('[data-lv3d-mode-desc]');
    var modeHint = modeDesc ? modeDesc.textContent : '';

    // Note explicative du mode (petit trait fixe en diagonale vers la tete)
    // avec une icone d'oscillation animee, plus forte en drainage.
    var callout = document.createElement('div');
    callout.className = 'lv3d__callout';
    callout.setAttribute('aria-live', 'polite');
    callout.innerHTML =
      '<svg class="lv3d__wire" aria-hidden="true"><path /></svg>' +
      '<span class="lv3d__note-icon lv3d__head-icon" aria-hidden="true"><svg viewBox="0 0 72 24" preserveAspectRatio="none">' +
      '<path d="M0 12 Q6 2 12 12 T24 12 T36 12 T48 12 T60 12 T72 12" /></svg></span>' +
      '<div class="lv3d__note">' +
      '<span class="lv3d__note-icon" aria-hidden="true"><svg viewBox="0 0 72 24" preserveAspectRatio="none">' +
      '<path d="M0 12 Q6 2 12 12 T24 12 T36 12 T48 12 T60 12 T72 12" /></svg></span>' +
      '<span class="lv3d__note-body"><span class="lv3d__note-title"></span><span class="lv3d__note-text"></span></span>' +
      '</div>';
    stage.appendChild(callout);
    var note = callout.querySelector('.lv3d__note');
    // La note vit dans un bandeau reserve au-dessus de la 3D (hors du cadre)
    // pour ne jamais recouvrir la brosse ; le trait reste dans le cadre.
    var notebar = document.createElement('div');
    notebar.className = 'lv3d__notebar';
    notebar.appendChild(note);
    // Mobile : au-dessus de la 3D. Ordinateur : colonne de droite, entre le
    // choix du mode et les caracteristiques.
    var mqDesk = window.matchMedia('(min-width: 750px)');
    var modesBox = root.querySelector('.lv3d__modes');
    var chipsBox = root.querySelector('.lv3d__chips');
    function placeNotebar() {
      if (mqDesk.matches && chipsBox) chipsBox.parentNode.insertBefore(notebar, chipsBox);
      else stage.parentNode.insertBefore(notebar, stage);
      root.classList.toggle('is-note-side', mqDesk.matches && !!chipsBox);
      callout.classList.toggle('is-desk', mqDesk.matches);
    }
    placeNotebar();
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', placeNotebar);
    var wirePath = callout.querySelector('.lv3d__wire path');
    var headIcon = callout.querySelector('.lv3d__head-icon');
    var noteIcon = note.querySelector('.lv3d__note-icon');
    var waveHTML = noteIcon.innerHTML;

    // Trait note -> tete : suit la brosse et ondule selon le mode, visible
    // seulement tant que la brosse est de profil (avant la reprise).
    function setWire(on) {
      state.wire = on;
      state.iconPlaced = false;
      callout.classList.toggle('has-wire', on);
      callout.classList.remove('has-icon');
    }
    var hint = panel ? panel.innerHTML : '';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var state = {
      auto: !reduced,
      idleSince: 0,
      open: -1,
      visible: false,
      dragging: false,
      mode: '',
      level: 0,
      facing: 0,
      callout: false,
      resumeAt: 0,
      wire: false,
      drop: 0,
      color: COLORS[root.dataset.color] ? root.dataset.color : 'blanc'
    };

    function setOpen(index) {
      state.open = index;
      points.forEach(function (p, i) {
        var on = i === index;
        p.classList.toggle('is-open', on);
        var btn = p.querySelector('[data-lv3d-toggle]');
        if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      chips.forEach(function (c, i) {
        c.classList.toggle('is-active', i === index);
        c.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      // La description du point s'affiche dans la note en haut de la 3D (meme
      // emplacement que la note du mode). Point ferme : retour a la note du mode.
      if (index >= 0) {
        var pop = points[index].querySelector('.lv3d__pop');
        showNote('point', pop.querySelector('.lv3d__pop-title').textContent, pop.querySelector('.lv3d__pop-text').innerHTML, true, points[index].dataset.icon);
      } else if (state.mode) {
        showCallout(true);
      } else {
        hideCallout();
      }
    }

    function hideCallout() {
      setWire(false);
      state.callout = false;
      callout.classList.remove('is-on');
      notebar.classList.remove('is-on');
      root.classList.remove('is-callout');
    }

    // kind = drainage / massage (icone + trait vers la tete) ou point.
    // html = true : texte riche de la description du point.
    function showNote(kind, title, text, html, iconType) {
      // Icone : onde pour les modes, icone animee propre a chaque « + ».
      if (kind === 'point') {
        var svg = FEATURE_ICONS[iconType];
        noteIcon.innerHTML = svg || '';
        noteIcon.classList.add('is-feature');
        notebar.dataset.icon = svg ? '1' : '';
      } else {
        noteIcon.innerHTML = waveHTML;
        noteIcon.classList.remove('is-feature');
        notebar.dataset.icon = '1';
      }
      note.querySelector('.lv3d__note-title').textContent = title;
      var body = note.querySelector('.lv3d__note-text');
      if (html) body.innerHTML = text;
      else body.textContent = text;
      callout.dataset.mode = kind;
      notebar.dataset.mode = kind;
      state.callout = true;
      callout.classList.add('is-on');
      notebar.classList.add('is-on');
    }

    // Note du mode : reste affichee tant qu'on n'ouvre pas un autre « + ».
    // quiet = pas de pause de la rotation (retour depuis un point).
    function showCallout(quiet) {
      var active = modeBtns.filter(function (b) {
        return b.dataset.lv3dMode === state.mode;
      })[0];
      if (!active || !active.dataset.note) return;
      showNote(state.mode, active.textContent.trim(), active.dataset.note);
      if (quiet) return;
      setWire(true);
      // La rotation reprend ~3 s apres l'apparition de la note ; les « + »
      // reviennent a ce moment-la.
      state.resumeAt = performance.now() + 3000;
      root.classList.add('is-callout');
    }

    // Remplacees une fois three.js charge.
    var faceTo = function () {};
    var showMode = function () {};
    var applyColor = function () {};

    // silent = mode par defaut au chargement (pas de pivot de la brosse).
    function setMode(name, silent) {
      state.mode = state.mode === name ? '' : name;
      modeBtns.forEach(function (b) {
        var on = b.dataset.lv3dMode === state.mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      root.classList.toggle('is-lit', !!state.mode);
      if (modeDesc) {
        var active = modeBtns.filter(function (b) {
          return b.dataset.lv3dMode === state.mode;
        })[0];
        modeDesc.textContent = active ? active.dataset.desc : modeHint;
      }
      if (silent) return;
      hideCallout();
      if (state.mode) {
        state.auto = false;
        showMode();
      } else {
        state.seq = null;
        state.idleSince = performance.now();
      }
    }
    modeBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        setMode(b.dataset.lv3dMode);
      });
    });
    if (MODES[root.dataset.defaultMode]) setMode(root.dataset.defaultMode, true);

    function setColor(name) {
      if (!COLORS[name]) return;
      state.color = name;
      colorBtns.forEach(function (b) {
        var on = b.dataset.lv3dColor === name;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyColor(name);
    }
    colorBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        setColor(b.dataset.lv3dColor);
      });
    });
    setColor(state.color);

    function openPoint(index, rotate) {
      if (state.open === index && !rotate) {
        setOpen(-1);
        state.idleSince = performance.now();
        return;
      }
      state.seq = null;
      state.resumeAt = 0;
      setWire(false);
      root.classList.remove('is-callout');
      setOpen(index);
      state.auto = false;
      state.idleSince = performance.now();
      if (rotate) faceTo(index);
    }

    points.forEach(function (p, i) {
      var btn = p.querySelector('[data-lv3d-toggle]');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        openPoint(i, false);
      });
    });
    chips.forEach(function (c, i) {
      c.addEventListener('click', function (e) {
        e.stopPropagation();
        openPoint(i, true);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(-1);
    });

    function start(THREE) {
      var renderer;
      try {
        renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' });
      } catch (err) {
        return;
      }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.outputColorSpace = THREE.SRGBColorSpace;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.18;
      renderer.setClearColor(0x000000, 0);
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;

      var scene = new THREE.Scene();
      scene.environment = studioEnvironment(THREE, renderer);

      // Lumiere principale en haut a gauche (ombres douces : espace sous la
      // tete, relief du bouton), contre-jour a droite pour detacher les bords.
      var key = new THREE.DirectionalLight(0xfff6ec, 2.4);
      // Placee sur le cote (z ~ 0) : son reflet ne peut pas revenir vers
      // l'ecran quand la face logo est tournee vers nous.
      key.position.set(-2.6, 3, 0.15);
      key.castShadow = true;
      key.shadow.mapSize.set(2048, 2048);
      key.shadow.camera.left = key.shadow.camera.bottom = -1;
      key.shadow.camera.right = key.shadow.camera.top = 1;
      key.shadow.camera.near = 0.5;
      key.shadow.camera.far = 8;
      key.shadow.bias = -0.0004;
      key.shadow.normalBias = 0.012;
      key.shadow.radius = 4;
      scene.add(key);
      var rim = new THREE.DirectionalLight(0xeef3ff, 1.1);
      rim.position.set(3, 1.2, -2.5);
      scene.add(rim);
      // Lumiere d'ambiance douce : eclaire les faces sans creer de reflet.
      scene.add(new THREE.HemisphereLight(0xffffff, 0xd6cec5, 0.85));

      var brush = buildBrush(THREE, COLORS[state.color]);
      scene.add(brush.pivot);

      var camera = new THREE.PerspectiveCamera(26, 1, 0.1, 50);
      camera.position.set(0, 0, 3.4);

      canvasWrap.appendChild(renderer.domElement);
      root.classList.add('is-3d');
      setTimeout(function () {
        playIntro();
      }, 0);

      // Orientation : rotation libre a 360 degres a l'horizontale (yaw) et
      // inclinaison limitee (pitch) : le haut du logo reste toujours vers le
      // haut de l'ecran, impossible de le retourner.
      var PITCH_MAX = 1.1;
      var view = { yaw: -0.55, pitch: 0.3 };
      var target = null;
      function clampPitch(p) {
        return Math.max(-PITCH_MAX, Math.min(PITCH_MAX, p));
      }
      function shortest(from, to) {
        var d = (to - from) % (Math.PI * 2);
        if (d > Math.PI) d -= Math.PI * 2;
        if (d < -Math.PI) d += Math.PI * 2;
        return from + d;
      }
      function aim(pitch, yaw) {
        return { pitch: clampPitch(pitch), yaw: shortest(view.yaw, yaw) };
      }

      // Couleurs : transition douce du corps et de la tete, logo remplace.
      var colorTarget = null;
      applyColor = function (name) {
        var p = COLORS[name];
        colorTarget = {
          body: new THREE.Color(p.body),
          head: new THREE.Color(p.head),
          glass: new THREE.Color(p.glass),
          neck: new THREE.Color(p.neck)
        };
        var old = brush.logoMat.map;
        brush.logoMat.map = logoTexture(THREE, p.logo, p.logoAlpha);
        brush.logoMat.needsUpdate = true;
        if (old) old.dispose();
      };

      // Ancrages en coordonnees du groupe interne.
      var anchors = points.map(function (p) {
        var a = ANCHORS[p.dataset.anchor] || ANCHORS.logo;
        return {
          p: new THREE.Vector3(a.p[0], a.p[1], a.p[2]),
          n: new THREE.Vector3(a.n[0], a.n[1], a.n[2]).normalize()
        };
      });

      faceTo = function (index) {
        var n = anchors[index].n;
        if (Math.abs(n.y) > 0.9) target = aim(n.y > 0 ? 0.85 : -0.8, -0.35);
        else target = aim(0.28, Math.atan2(-n.x, n.z) + 0.25);
      };

      // Changement de mode : face avant (logo allume), puis profil pour
      // bien voir l'oscillation de la tete, puis la note s'affiche.
      showMode = function () {
        target = null;
        state.seq = { phase: 0, t: performance.now() };
        tweenTo(aim(0.1, 0), 650);
      };

      // Rotation minutee et adoucie (ease in-out) pour la sequence de mode.
      var tween = null;
      function tweenTo(to, dur) {
        tween = { from: { yaw: view.yaw, pitch: view.pitch }, to: to, t0: performance.now(), dur: dur };
      }
      function ease(p) {
        return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      }

      var glowColor = new THREE.Color(0x000000);
      var tmpColor = new THREE.Color();

      function animateMode(now, dt) {
        var mode = MODES[state.mode];
        // Fondu d'allumage / d'extinction.
        state.level += ((mode ? 1 : 0) - state.level) * Math.min(1, dt * 6);
        if (mode) {
          tmpColor.setHex(mode.glow);
          glowColor.lerp(tmpColor, Math.min(1, dt * 8));
          state.cur = mode;
        }
        var m = state.cur;
        if (!m || state.level < 0.002) {
          brush.head.rotation.z = 0;
          brush.head.position.set(0, 0, 0);
          brush.logoMat.emissiveIntensity = 0;
          brush.logoMat.color.setScalar(1);
          brush.haloMat.opacity = 0;
          renderer.toneMappingExposure = 1.18;
          return;
        }
        var t = now / 1000;
        var wave = 0.5 + 0.5 * Math.sin(t * Math.PI * 2 * m.pulseHz);
        // Drainage : pulsations franches (quasi creneau). Massage : plus souple.
        var env = m.sharp ? Math.pow(wave, 0.35) : 0.4 + 0.6 * wave;
        if (!mode) env = 1;
        var lvl = state.level;
        var w = t * Math.PI * 2 * m.freq;
        var amp = env * lvl;
        brush.head.rotation.z = Math.sin(w) * m.osc * amp;
        // Oscillation horizontale et verticale de la tete.
        brush.head.position.x = Math.sin(w * 0.9) * m.shake * amp;
        brush.head.position.y = Math.cos(w * 1.15) * m.shake * amp;
        brush.head.position.z = -m.push * amp * (0.6 + 0.4 * Math.abs(Math.sin(w)));
        // Logo : lumiere forte et constante (pas de clignotement).
        brush.logoMat.color.setScalar(1 - 0.92 * lvl);
        brush.logoMat.emissive.copy(glowColor);
        // Intensite identique sous tous les angles (aucun surplus de face).
        brush.logoMat.emissiveIntensity = m.glowMax * lvl;
        // Halo tres leger : le logo doit rester net et lisible (pas de flou).
        brush.haloMat.color.copy(glowColor);
        brush.haloMat.opacity = 0;
        renderer.toneMappingExposure = 1.18 - 0.14 * lvl;
      }

      var baseZ = 3.4;

      function resize() {
        var w = canvasWrap.clientWidth;
        var h = canvasWrap.clientHeight;
        if (!w || !h) return;
        renderer.setSize(w, h, false);
        camera.aspect = w / h;
        // Cadrage : la sphere englobante remplit ~92 % du cadre.
        var half = (camera.fov * Math.PI) / 360;
        // Ordinateur : la brosse remplit tout le cadre (la sphere englobante
        // garantit qu'elle n'est jamais coupee, quelle que soit l'orientation).
        baseZ = brush.radius / Math.sin(half) / (mqDesk.matches ? 1 : 0.92) / Math.min(1, camera.aspect);
        // La zone 3D remonte sous la note : le haut de la brosse (meme
        // redressee au maximum) arrive juste sous la note, sans la toucher.
        stage.style.marginTop = mqDesk.matches ? '' : -Math.max(0, Math.round(h * 0.13) - 10) + 'px';
        // Mobile : on resserre aussi le bas (le contenu remonte sous la brosse).
        stage.style.marginBottom = mqDesk.matches ? '' : -Math.round(h * 0.08) + 'px';
        camera.updateProjectionMatrix();
      }
      resize();
      if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvasWrap);
      else window.addEventListener('resize', resize);

      // Glisser : horizontal = tourne a 360 degres, vertical = incline.
      var last = null;
      renderer.domElement.addEventListener('pointerdown', function (e) {
        last = { x: e.clientX, y: e.clientY };
        state.dragging = true;
        state.auto = false;
        target = null;
        tween = null;
        if (state.seq && !state.callout && state.mode) showCallout(true);
        state.seq = null;
        state.resumeAt = 0;
        setWire(false);
        root.classList.remove('is-callout');
        renderer.domElement.setPointerCapture(e.pointerId);
      });
      renderer.domElement.addEventListener('pointermove', function (e) {
        if (!last) return;
        var dx = e.clientX - last.x;
        var dy = e.clientY - last.y;
        view.yaw += dx * 0.011;
        view.pitch = clampPitch(view.pitch + dy * 0.009);
        last = { x: e.clientX, y: e.clientY };
      });
      function endDrag() {
        last = null;
        state.dragging = false;
        state.idleSince = performance.now();
      }
      renderer.domElement.addEventListener('pointerup', endDrag);
      renderer.domElement.addEventListener('pointercancel', endDrag);

      var raycaster = new THREE.Raycaster();
      var world = new THREE.Vector3();
      var normal = new THREE.Vector3();
      var toCam = new THREE.Vector3();
      var nMat = new THREE.Matrix3();
      var clock = performance.now();
      var frame = 0;

      function tick(now) {
        requestAnimationFrame(tick);
        if (!state.visible) {
          clock = now;
          return;
        }
        var dt = Math.min(0.05, (now - clock) / 1000);
        clock = now;

        // Sequence de mode : face logo (courte), puis quart de tour vers la
        // gauche, la note apparait pendant la rotation.
        if (state.seq) {
          if (state.seq.phase === 0 && now - state.seq.t > 950) {
            state.seq = { phase: 1, t: now };
            tweenTo(aim(0.1, 1.45), 1700);
          } else if (state.seq.phase === 1 && !state.callout && now - state.seq.t > 900) {
            showCallout();
          } else if (state.seq.phase === 1 && !tween) {
            state.seq = null;
          }
        }
        if (tween) {
          var tp = Math.min(1, (now - tween.t0) / tween.dur);
          var te = ease(tp);
          view.yaw = tween.from.yaw + (tween.to.yaw - tween.from.yaw) * te;
          view.pitch = tween.from.pitch + (tween.to.pitch - tween.from.pitch) * te;
          if (tp >= 1) tween = null;
        }
        if (state.callout && state.resumeAt && now > state.resumeAt && !tween && !state.dragging) {
          state.resumeAt = 0;
          state.seq = null;
          state.auto = !reduced;
          setWire(false);
          root.classList.remove('is-callout');
        }
        if (!state.auto && !tween && !state.seq && !state.resumeAt && !state.dragging && !target && !reduced && now - state.idleSince > 1000) {
          state.auto = true;
        }
        if (state.auto) {
          view.yaw += dt * 0.42;
          view.pitch += (0.3 - view.pitch) * Math.min(1, dt * 1.5);
        }
        if (target) {
          var e = Math.min(1, dt * 5);
          view.yaw += (target.yaw - view.yaw) * e;
          view.pitch += (target.pitch - view.pitch) * e;
          if (Math.abs(target.yaw - view.yaw) + Math.abs(target.pitch - view.pitch) < 0.004) {
            target = null;
            // La rotation reprend 1 s apres l'arrivee sur le point.
            state.idleSince = now;
          }
        }
        if (colorTarget) {
          var k = Math.min(1, dt * 8);
          brush.bodyMat.color.lerp(colorTarget.body, k);
          brush.cylMat.color.lerp(colorTarget.body, k);
          brush.btnMat.color.lerp(colorTarget.body, k);
          brush.glassMat.color.lerp(colorTarget.glass, k);
          brush.headMat.color.lerp(colorTarget.head, k);
          brush.neckMat.color.lerp(colorTarget.neck, k);
        }

        // Orientation de la face logo par rapport a la camera (0 = de biais,
        // 1 = pile en face), calculee sur l'image precedente.
        nMat.getNormalMatrix(brush.inner.matrixWorld);
        normal.set(0, 0, 1).applyMatrix3(nMat).normalize();
        world.set(0, 0, GLASS_Z).applyMatrix4(brush.inner.matrixWorld);
        toCam.copy(camera.position).sub(world).normalize();
        state.facing = Math.max(0, normal.dot(toCam));
        animateMode(now, dt);
        // Pendant la note, la brosse descend un peu pour laisser la place.
        camera.position.z = baseZ;
        brush.pivot.rotation.set(view.pitch, view.yaw, 0, 'XYZ');
        brush.pivot.updateMatrixWorld(true);
        renderer.render(scene, camera);

        // Trait ondulant : mobile = de la note vers le haut de la tete ;
        // ordinateur = trait vertical seul, juste a gauche de la tete.
        if (state.wire) {
          var ax, ay, hx, hy;
          if (mqDesk.matches) {
            // Ordinateur : l'icone d'oscillation de la note, a l'horizontale,
            // au-dessus de la tete. Placee une seule fois, brosse arretee de
            // profil (sans l'oscillation), puis fixe.
            if (!state.iconPlaced && !tween) {
              var ht = brush.inner.localToWorld(new THREE.Vector3(0, HEAD_R + 0.02, HEAD_Z - HEAD_T / 2)).project(camera);
              var ix = (ht.x * 0.5 + 0.5) * canvasWrap.clientWidth - headIcon.offsetWidth / 2;
              var iy = (-ht.y * 0.5 + 0.5) * canvasWrap.clientHeight - headIcon.offsetHeight - 14;
              headIcon.style.transform = 'translate3d(' + ix.toFixed(1) + 'px,' + iy.toFixed(1) + 'px,0)';
              state.iconPlaced = true;
              callout.classList.add('has-icon');
            }
          } else {
            var hp = brush.head.localToWorld(world.set(0, HEAD_R + 0.004, HEAD_Z - HEAD_T / 2)).project(camera);
            hx = (hp.x * 0.5 + 0.5) * canvasWrap.clientWidth;
            hy = (-hp.y * 0.5 + 0.5) * canvasWrap.clientHeight;
            var sr = stage.getBoundingClientRect();
            var nr = note.getBoundingClientRect();
            ax = Math.max(nr.left + 18, Math.min(nr.right - 18, sr.left + hx)) - sr.left;
            ay = nr.bottom - sr.top;
          }
          if (!mqDesk.matches) {
          var dx = hx - ax;
          var dy = hy - ay;
          var len = Math.sqrt(dx * dx + dy * dy) || 1;
          var px = -dy / len;
          var py = dx / len;
          var strong = state.mode === 'drainage';
          var amp = strong ? 5 : 2.2;
          var speed = strong ? 2.6 : 1.05;
          var waves = Math.max(2, len / 26);
          var d = '';
          for (var si = 0; si <= 48; si++) {
            var u = si / 48;
            var off = Math.sin(u * Math.PI * 2 * waves - (now / 1000) * Math.PI * 2 * speed) * amp * Math.sin(u * Math.PI);
            d += (si ? 'L' : 'M') + (ax + dx * u + px * off).toFixed(1) + ' ' + (ay + dy * u + py * off).toFixed(1);
          }
          wirePath.setAttribute('d', d);
          }
        }

        // Position des « + » : projection + test de visibilite.
        var w = canvasWrap.clientWidth;
        var h = canvasWrap.clientHeight;
        nMat.getNormalMatrix(brush.inner.matrixWorld);
        frame++;
        for (var i = 0; i < anchors.length; i++) {
          world.copy(anchors[i].p).applyMatrix4(brush.inner.matrixWorld);
          normal.copy(anchors[i].n).applyMatrix3(nMat).normalize();
          toCam.copy(camera.position).sub(world).normalize();
          var shown = normal.dot(toCam) > 0.2;
          if (shown && frame % 2 === 0) {
            raycaster.set(camera.position, world.clone().sub(camera.position).normalize());
            var hit = raycaster.intersectObjects(brush.solids, false)[0];
            if (hit && hit.distance < camera.position.distanceTo(world) - 0.02) shown = false;
            anchors[i].occluded = !shown;
          } else if (shown && anchors[i].occluded) {
            shown = false;
          }
          var sp = world.clone().project(camera);
          var x = (sp.x * 0.5 + 0.5) * w;
          var y = (-sp.y * 0.5 + 0.5) * h;
          var el = points[i];
          el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
          el.classList.toggle('is-hidden', !shown);
        }
      }
      requestAnimationFrame(tick);
    }

    // Chargement paresseux : quand la section approche de l'ecran.
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          state.visible = entry.isIntersecting;
          if (entry.isIntersecting && !root.dataset.lv3dLoading) {
            root.dataset.lv3dLoading = '1';
            loadThree()
              .then(start)
              .catch(function () {
                root.classList.add('is-fallback');
              });
          }
        });
      },
      { rootMargin: '300px 0px' }
    );
    io.observe(stage);

    // Arrivee sur la section : le mode par defaut joue son animation, comme
    // si on venait de cliquer sur le bouton.
    var introDone = false;
    var introWanted = false;
    var intro = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || introDone) return;
          introWanted = true;
          playIntro();
        });
      },
      { threshold: 0.45 }
    );
    intro.observe(stage);
    function playIntro() {
      if (introDone || !introWanted || !root.classList.contains('is-3d') || !state.mode) return;
      introDone = true;
      intro.disconnect();
      state.auto = false;
      showMode();
    }
  }

  function boot() {
    document.querySelectorAll('[data-lv3d]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-lv3d]');
    if (el) init(el);
  });
})();
